/**
 * Le TEXTE SUPPORT d'une variante de compréhension de l'écrit (10/10/2026).
 *
 * Une variante d'un item de compréhension garde son item (son Label : sa partie du quiz, sa comparaison avec
 * septembre) mais lit son PROPRE texte. Elle n'en range que la RÉFÉRENCE, dans
 * elements_additionnels.support_lecture = { id, titre } (11/10 : le texte avec ses images pesait jusqu'à
 * 59 Ko, recopiés sur chaque variante en base). Le texte complet vit dans son module de générateurs et se
 * retrouve par son id (generators/evalnat/supports.js, supportDeQuestion). Ses pages ont la forme de celles
 * du livre, LivreImmersif (title, surtitre, content, images [{ src, alt }], legende, source).
 * Les afficheurs d'éléments ne lisent que elements_additionnels.elements : la clé leur est invisible.
 */
const lire = (elementsAdditionnels) => {
    if (!elementsAdditionnels) return null;
    if (typeof elementsAdditionnels === 'string') {
        try { return JSON.parse(elementsAdditionnels); } catch { return null; }
    }
    return typeof elementsAdditionnels === 'object' ? elementsAdditionnels : null;
};

/** La référence du texte d'une question telle qu'elle est rangée ({ id, titre }, ou des pages), ou null. */
export const referenceSupportLecture = (question) => {
    const ref = lire(question?.elements_additionnels)?.support_lecture;
    if (!ref || typeof ref !== 'object') return null;
    return ref.id || (Array.isArray(ref.pages) && ref.pages.length > 0) ? ref : null;
};

/** Le payload d'une variante, la référence de son texte posée dans elements_additionnels (éléments gardés). */
export const avecSupportLecture = (payload, support) => ({
    ...payload,
    elements_additionnels: {
        version: 1,
        elements: [],
        ...(lire(payload?.elements_additionnels) || {}),
        support_lecture: { id: support.id, titre: support.titre },
    },
});
